module.exports = new __parcel__URL__("jpd-board-blank-darkmode.2dd3213c.svg").toString();